import styled from '@emotion/styled';
import { Text } from '../atoms/Text';
import { isSafeInlineSvg, type LogoCustomizationAsset } from '../customization';

export interface BrandLogoProps {
  logo?: LogoCustomizationAsset;
  fallbackText: string;
  className?: string;
  decorative?: boolean;
}

const LogoImage = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

const InlineSvg = styled.span`
  display: inline-flex;
  align-items: center;

  svg {
    display: block;
    max-width: 100%;
    height: auto;
  }
`;

export function BrandLogo({ logo, fallbackText, className, decorative = false }: BrandLogoProps) {
  if (logo?.src) {
    return (
      <LogoImage
        className={className}
        src={logo.src}
        alt={decorative ? '' : logo.alt || fallbackText}
        width={logo.width}
        height={logo.height}
      />
    );
  }

  const inlineSvg = logo?.inlineSvg;

  if (isSafeInlineSvg(inlineSvg)) {
    return (
      <InlineSvg
        className={className}
        role={decorative ? 'presentation' : 'img'}
        aria-hidden={decorative || undefined}
        aria-label={decorative ? undefined : logo?.alt || fallbackText}
        dangerouslySetInnerHTML={{ __html: inlineSvg }}
      />
    );
  }

  return (
    <Text className={className} variant="body" weight="bold">
      {fallbackText}
    </Text>
  );
}
